import React from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import SEO from "../common/SEO";
import SectionTitle from "../elements/section-title/SectionTitle";
import AboutThree from "../component/about/AboutThree";
import CounterUpTwo from "../component/counterup/CounterUpTwo";
import ServicePropOne1 from "../component/service/ServicePropOne1";
import SectionTitle2 from "../elements/section-title2/SectionTitle2";
import BcrumbBannerTwo from "../elements/breadcrumb/BcrumbBannerTwo";
import { useLocation } from "react-router-dom";
import ClientSlider from "../component/client/ClientSlider";

const bannerDataMapping = {
  "/service/ifm-services": {
    descriptionTitle:
      "UCWF Facilities Management Services: Integrated Solutions for Total Facility Efficiency and Performance ",
    description:
      " UCWF  offers integrated facilities management (IFM) services designed to streamline operations, enhance efficiency, and ensure a seamless experience for our clients. Our comprehensive approach covers both hard and soft services, including HVAC, electrical, plumbing, security, cleaning, landscaping, waste management, and more. We prioritize sustainability, cost-effectiveness, and safety, leveraging advanced technologies to provide proactive solutions and prevent issues before they arise. Whether you manage a single building or a complex portfolio, UCWF’s IFM solutions are tailored to meet the unique needs of your property, ensuring optimal performance and long-term value. ",
    data: [
      {
        title:
          "Comprehensive Integrated Facilities Management Solutions for Seamless Operations",
        mainThumb: "/images/serviceucwf/ifm-service/ifm-banner1.webp",
      },
      {
        title:
          "Innovate, Optimize, Elevate – The Future of Facility Management ",
        mainThumb: "/images/serviceucwf/ifm-service/ifm-banner2.webp",
      },
      {
        title: "Next-Gen Facility Services for a Seamless Experience ",
        mainThumb: "/images/serviceucwf/ifm-service/ifm-banner3.webp",
      },
    ],
  },
  "/service/hard-services": {
    descriptionTitle:
      "UCWF Facilities Management Services: Comprehensive Hard Services for Seamless Building Operations ",
    description:
      "At UCWF Facilities Management Services, we understand the importance of hard services in ensuring the smooth operation, safety, and comfort of your building. We specialize in the maintenance of critical systems, including HVAC (Heating, Ventilation, and Air Conditioning), Electrical, and  Plumbing , which are essential for your building’s functionality.",
    data: [
      {
        title:
          "Maximizing Efficiency in HVAC, Electrical and Plumbing Systems Through Effective Preventive and Reactive Maintenance ",
        mainThumb: "/images/serviceucwf/hard-service/hard-service-banner1.webp",
      },
      {
        title:
          "Enhancing Building Performance through Proactive Maintenance Boosts Operational Efficiency, Minimizes Downtime and Maximizes Asset Longevity ",
        mainThumb: "/images/serviceucwf/hard-service/hard-service-banner2.webp",
      },
      {
        title:
          "Optimizing Property Functionality with Expert Hard Services Maintenance",
        mainThumb: "/images/serviceucwf/hard-service/hard-service-banner3.webp",
      },
    ],
  },
  "/service/soft-services": {
    descriptionTitle:
      "UCWF Facilities Management Services: Comprehensive Soft Services for Optimal Workplace Efficiency",
    description:
      "At UCWF Facilities Management, we offer exceptional housekeeping, facade cleaning, and pest control services to maintain a clean, safe, and healthy environment. Using advanced equipment and eco-friendly solutions, our housekeeping team ensures interior cleanliness and hygiene. We specialize in facade cleaning through BMU and rope access techniques for efficient and safe exterior maintenance. Our pest control services include preventive treatments and safe removal to ensure a pest-free and hygienic space for all occupants.",
    data: [
      {
        title:
          "Building Cleaning Services Ensure a Hygienic Environment by Maintaining Cleanliness and Promoting Overall Health and Safety ",
        mainThumb: "/images/serviceucwf/soft-service/soft-service-banner1.webp",
      },
      {
        title:
          "Elevating Housekeeping with Modern Equipment for Unmatched Cleanliness and Efficiency ",
        mainThumb: "/images/serviceucwf/soft-service/soft-service-banner2.webp",
      },
      {
        title:
          "Ensuring Safety, Efficiency and Thorough Cleaning with BMU and Rope Access Solutions",
        mainThumb: "/images/serviceucwf/soft-service/soft-service-banner3.webp",
      },
    ],
  },
  "/service/security-services": {
    descriptionTitle:
      "UCWF Facilities Management Services: Comprehensive Security Solutions for Maximum Safety and Protection",
    description:
      "Our Security services in the UAE offer comprehensive protection to ensure the safety and security of individuals, properties, and businesses. These services are designed to meet the unique needs of the region, leveraging advanced technology and highly trained personnel. From 24/7 surveillance, access control systems, and alarm monitoring to on-site security teams and emergency response, security providers in the UAE deliver tailored solutions for residential, commercial, and industrial sectors. With a strong focus on professionalism and adherence to local regulations, these services offer peace of mind while ensuring safety across diverse environments. Whether it's protecting assets, people, or critical infrastructure, security services in the UAE are equipped to handle a wide range of security needs.",
    data: [
      {
        title:
          "Tailored Security Services Based on the Specific Needs of Businesses, Residential Properties and Industrial Facilities ",
        // paragraph: "Your Safety, Our Priority!",
        mainThumb:
          "/images/serviceucwf/security-service/security-service-banner1.webp",
      },
      {
        title:
          "Regular Mobile Patrols and Rapid Response Teams to Ensure Safety Across Large Areas or Multiple Locations ",
        // paragraph: "Providing 24/7 security services.",
        mainThumb:
          "/images/serviceucwf/security-service/security-service-banner2.webp",
      },
      {
        title: "Elevating Your Lifestyle with Concierge and Lifeguard Services",
        // paragraph: "Providing 24/7 security services.",
        mainThumb:
          "/images/serviceucwf/security-service/security-service-banner3.webp",
      },
    ],
  },
  "/service/specialized-services": {
    descriptionTitle:
      "UCWF Facilities Management Services: Specialized Solutions for Elevators, Fire Systems, and Critical Building Equipment Maintenance ",
    description:
      "Our solutions ensure the smooth operation and maintenance of fire systems, elevators, water systems, and critical infrastructure, in full compliance with local authorities and regulations. We provide customized services to keep systems in peak condition, reducing downtime and improving safety. Whether through regular inspections, emergency repairs, or system upgrades, our skilled team offers reliable, cost-effective maintenance that meets industry standards and local regulatory requirements. Focused on efficiency, we help extend the lifespan of your systems while maintaining a safe and functional property in line with local guidelines.",
    data: [
      {
        title:
          "Expert Elevator, ELV System and BMU Maintenance for Optimal Property Performance",
        // paragraph: "Complete Building Care",
        mainThumb:
          "/images/serviceucwf/specialized-service/specialized-service-banner-1.webp",
      },
      {
        title:
          "Reliable Fire Alarm, Fire Fighting and ELV System Maintenance for Safety and Efficiency ",
        // paragraph: "Your Trusted Maintenance Partner",
        mainThumb:
          "/images/serviceucwf/specialized-service/specialized-service-banner-2.webp",
      },
      {
        title:
          "Expert Landscaping Services and Maintenance for Beautiful, Healthy Outdoor Spaces ",
        // paragraph: "Your Trusted Maintenance Partner",
        mainThumb:
          "/images/serviceucwf/specialized-service/specialized-service-banner-3.webp",
      },
    ],
  },
};

// Map paths to breadcrumb names
const pathToBreadcrumb = {
  "/service/ifm-services": "IFM-Services",
  "/service/hard-services": "Hard-Services",
  "/service/soft-services": "Soft-Services",
  "/service/security-services": "Security-Services",
  "/service/specialized-services": "Specialized-Services",
};
const formatBreadcrumb = (str) => {
  return str.replace(/-/g, " "); // Replace all hyphens with spaces
};

const ServiceTwo = () => {
  const location = useLocation(); // Get the current location
  const serviceData = bannerDataMapping[location.pathname] || {
    description: "",
    data: [],
  }; // Default to empty array if path not found

  const currentBreadcrumb = pathToBreadcrumb[location.pathname] || "";

  return (
    <>
      <SEO title="Service Two" />

      <main className="main-wrapper">
        <HeaderOne />
        <BcrumbBannerTwo
          titleCategory={formatBreadcrumb(currentBreadcrumb)}
          bannerData={serviceData.data}
          page={currentBreadcrumb}
        />

        <div
          className="section  bg-color-light"
          style={{ paddingTop: "60px", paddingBottom: "60px" }}
        >
          <div className="container">
            <h3 className=" h3" style={{ color: "#562b7a" }}>
              {serviceData.descriptionTitle}
            </h3>
            <p
              dangerouslySetInnerHTML={{ __html: serviceData.description }}
            ></p>

            <SectionTitle2
              subtitle="What We Can Do For You"
              title="Services we can help you with"
              description=""
              textAlignment="heading-left"
              textColor=""
            />
            <div className="row">
              <ServicePropOne1
                colSize="col-lg-4 col-md-6"
                serviceStyle="service-style-2"
                itemShow="20"
                marginTop="no"
              />
            </div>
          </div>
        </div>
        <CounterUpTwo />
        <AboutThree />
        <div className="container " style={{ paddingTop: "100px" }}>
          <SectionTitle
            subtitle="Our Clients"
            title="Our valued partners"
            textAlignment="heading-left mb--40"
            textColor=""
          />
        </div>
        <ClientSlider
          itemShow={4}
          colSize="col-md-3"
          columnGap="row-35"
          parentClass="your-custom-class"
        />

        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default ServiceTwo;
